export default __webpack_public_path__ + "static/media/profile-info.ba344849.png";